import { useState } from 'react'
import { Box, Modal, Radio, RadioGroup, FormControlLabel, Button, TextField } from '@mui/material'
import { brand, fontFamily, headingSx, subtextSx, btnPrimarySx, btnSecondarySx } from './protoTheme'

const REASONS = [
    { value: 'offset', label: 'The angle looks wrong', hint: 'Data exists but it\'s offset' },
    { value: 'zone', label: 'The working zone changed', hint: 'The pivot now covers a different distance' },
    { value: 'relocated', label: 'The device was moved to a different field', hint: 'Full setup from scratch' }
]

const modalBoxSx = {
    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    width: 420, maxWidth: '92vw', bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2, fontFamily
}

const RecalibrateModal = ({ open, onClose, onPickReason }) => {
    const [reason, setReason] = useState('offset')
    const [angle, setAngle] = useState('')
    const [quickMode, setQuickMode] = useState(false)

    const handleContinue = () => {
        if (reason === 'offset') {
            setQuickMode(true)
            return
        }
        onPickReason(reason)
    }

    const handleQuickSave = () => {
        onPickReason('offset', Number(angle))
    }

    const handleClose = () => {
        setQuickMode(false)
        setAngle('')
        setReason('offset')
        onClose()
    }

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={modalBoxSx}>
                {!quickMode ? (
                    <>
                        <h3 style={headingSx}>What happened?</h3>
                        <RadioGroup value={reason} onChange={(e) => setReason(e.target.value)} sx={{ mt: 2 }}>
                            {REASONS.map((r) => (
                                <Box key={r.value} sx={{ mb: 1.5 }}>
                                    <FormControlLabel
                                        value={r.value}
                                        control={<Radio sx={{ color: brand.navy, '&.Mui-checked': { color: brand.navy } }} />}
                                        label={r.label}
                                        sx={{ '& .MuiFormControlLabel-label': { fontFamily, fontSize: 14 } }}
                                    />
                                    <div style={{ ...subtextSx, fontSize: 12, marginLeft: 32 }}>{r.hint}</div>
                                </Box>
                            ))}
                        </RadioGroup>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
                            <Button sx={{ ...btnSecondarySx, border: 'none' }} onClick={handleClose}>Cancel</Button>
                            <Button variant="contained" sx={btnPrimarySx} onClick={handleContinue}>Continue</Button>
                        </Box>
                    </>
                ) : (
                    <>
                        <h3 style={headingSx}>Current angle</h3>
                        <TextField
                            label="Angle from panel" type="number" variant="standard" fullWidth sx={{ mt: 2 }}
                            value={angle} onChange={(e) => setAngle(e.target.value)}
                            helperText="Enter the value from the panel"
                        />
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 3 }}>
                            <Button sx={{ ...btnSecondarySx, border: 'none' }} onClick={handleClose}>Cancel</Button>
                            <Button variant="contained" sx={btnPrimarySx} disabled={angle === ''} onClick={handleQuickSave}>Save</Button>
                        </Box>
                    </>
                )}
            </Box>
        </Modal>
    )
}

export default RecalibrateModal
